import { differenceInDays } from 'date-fns';
import { useLang } from 'hooks/lang';

import { TaskWithSub, taskOverviewConfig } from 'entities';

import { Row } from 'components/Blocks';
import { CalendarIcon, WarningIcon } from 'components/Icons';

import { getDateWithMonthText } from 'utils/date';

interface TaskDateProps {
  children?: never;
  task: TaskWithSub;
}

function TaskDate({ task }: TaskDateProps) {
  const { t } = useLang();

  const isDelayed = taskOverviewConfig.overdue.checker(task);

  const expectedDate = new Date(task.expectedDate as string);

  return (
    <Row inLine gap="2" className="phone:mx-auto phone:flex-col">
      {isDelayed && (
        <Row gap="2" className="phone:order-2">
          <span className="text-xs text-warning">
            {Math.abs(differenceInDays(expectedDate, new Date()))} {t('days-late')}
          </span>

          <WarningIcon color="warning" />
        </Row>
      )}

      <Row gap="2" className="phone:order-1">
        {getDateWithMonthText(expectedDate)}

        <CalendarIcon />
      </Row>
    </Row>
  );
}

export default TaskDate;
